module.exports = __webpack_public_path__ + "img/doubleblack_freeride-2q1BbTJ.svg";